import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessControl } from '@/hooks/useAccessControl';
import { useDashboardReleases } from '@/hooks/useDashboardReleases';
import { Settings, LogOut, Clock, AlertCircle, CheckCircle, PauseCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ClientList from './ClientList';
import ReleasesList from './ReleasesList';

const AdminPanel: React.FC = () => {
  const { isAdmin, isLoading, clients, logout } = useAccessControl();
  const navigate = useNavigate();
  const { releases, isLoading: isLoadingReleases } = useDashboardReleases(clients);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <h1 className="text-3xl font-bold flex items-center">
            <Settings size={24} className="mr-2" /> Admin Dashboard
          </h1>
        </div>
        
        <Button 
          variant="outline" 
          onClick={handleLogout} 
          className="flex items-center gap-2"
        >
          <LogOut size={16} />
          <span>Log Out</span>
        </Button>
      </div>

      {/* Release Lists */}
      <div className="grid grid-cols-1 gap-6 mb-6">
        <ReleasesList 
          releases={releases}
          isLoading={isLoadingReleases}
          title="On Hold"
          icon={<PauseCircle className="w-5 h-5 text-white" />}
          status="on hold"
        />
        <ReleasesList 
          releases={releases}
          isLoading={isLoadingReleases}
          title="Not Ready"
          icon={<AlertCircle className="w-5 h-5 text-white" />}
          status="not ready"
        />
        <ReleasesList 
          releases={releases}
          isLoading={isLoadingReleases}
          title="Ready for Release"
          icon={<Clock className="w-5 h-5 text-white" />}
          status="ready for release"
        />
        <ReleasesList 
          releases={releases}
          isLoading={isLoadingReleases}
          title="Released"
          icon={<CheckCircle className="w-5 h-5 text-white" />}
          status="released"
        />
      </div>

      {/* Clients Management */}
      <div className="grid grid-cols-1 gap-6">
        <ClientList />
      </div>
    </div>
  );
};

export default AdminPanel;
